// extracted by mini-css-extract-plugin
export default {"layout":"AuthRoot2_layout__LKiQu","left":"AuthRoot2_left__0Qfmv","right":"AuthRoot2_right__Mmq2G","authSlider":"AuthRoot2_authSlider__bOtVZ","container":"AuthRoot2_container__1xZcQ"};